// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 563) return "../css/7.0.35156-app-client-developer-side-nav.min.css";
	// return url for filenames based on template
	return undefined;
};